import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { actionCreators } from '../../store/Login';
import { bindActionCreators } from 'redux';
import { UserRoles, EditState } from '../shared/enums';
import { Col, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';
import "./Home.css";

class ItemsList extends React.Component {
    displayName = ItemsList.name;
    render() {
        var items = this.props.items.map((item, index) => {
            return (
                <ItemsListItem editMode={this.props.editMode} key={index} index={index} item={item}
                    onClickRemove={this.props.onClickRemove} onChangeButtonText={this.props.onChangeButtonText}
                    onChangeLink={this.props.onChangeLink} isCopyHome={this.props.isCopyHome}
                    setIsChecked={this.props.setIsChecked}
                />
            );
        });
        return (
            <ul className={"list-group " + (this.props.editMode === EditState.List ? 'quickLinks' : 'quickLinksEdit')}>{items}</ ul>
        );
    }
}

class ItemsListItem extends React.Component {
    displayName = ItemsListItem.name;
    render() {
        return (
            <div>
                {this.props.editMode === EditState.Edit &&
                    <li className="list-group-item ">
                        <Row>
                            <Col xs={11} >
                                <input
                                    type="text"
                                    className="form-control HomeItemInput"
                                    value={this.props.item.buttonText}
                                    placeholder="Enter Button Text"
                                    onChange={(e) => this.props.onChangeButtonText(this.props.index, e)}
                                />
                            </Col>
                            <Col xs={1} style={{ padding: '0px 10px 0px 10px' }}>
                                <button className="pull-right btn btn-outline-danger btn-sm deleteButton" onClick={(e) => this.props.onClickRemove(this.props.index, e)} >
                                    X
                                </button>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={11}>
                                <input
                                    type="text"
                                    className="form-control HomeItemInput"
                                    value={this.props.item.link}
                                    title="ex: /CreateSalesOrder, /Report/SOHistory"
                                    placeholder="Enter Link" onChange={(e) => this.props.onChangeLink(this.props.index, e)}
                                />
                            </Col>
                        </Row>
                    </li>
                }
                {this.props.editMode === EditState.List &&
                    <li >
                        <div className="home-item">
                            <form target={(this.props.item.link === null || this.props.item.link.substring(0, 1) === '/') ? "" : "_blank"} action={this.props.item.link}>
                                <input className="ogcButton quickLinksButton" type="submit" value={this.props.item.buttonText} />
                            </form>
                            {this.props.isCopyHome &&
                                <div style={{display:'inline-block', float:'right'}}>
                                    <label htmlFor="test" />
                                    <label className="homeCheckbox">
                                        <input type="checkbox" name="test" checked={this.props.item.isChecked} onChange={(e) => this.props.setIsChecked(this.props.item)} />
                                        <span />
                                    </label>
                                </div>
                            }
                        </div>
                    </li>
                }
            </div>
        );
    }
}

class ItemsHeader extends React.Component {
    displayName = QuickLinks.name;

    render() {
        return (
            <div className="ogcText">
                {!this.props.isCopyHome &&
                    <div style={{ display: 'inline-block', float: 'right' }}>
                        {this.props.showEditControls && this.props.editMode === EditState.List &&
                            <button className="ogcButton btn-std-size" onClick={this.props.onClickEdit}>Edit</button>
                        }
                        {this.props.showEditControls && this.props.editMode === EditState.Edit &&
                            <React.Fragment>
                                <button className="ogcButton btn-std-size" onClick={this.props.onClickAdd}>Add</button>
                                <button className={(this.props.isDirty) ? "ogcButton btn-std-size" : "ogcDisabledButton btn-std-size"} onClick={this.props.onClickSubmit} disabled={!this.props.isDirty}>Submit</button>
                                <button className="ogcButton btn-std-size" onClick={this.props.onClearItems}>Clear All</button>
                                <button className="ogcButton ogcButton-brown btn-std-size" onClick={this.props.onClickCancel}>Cancel</button>
                            </React.Fragment>
                        }
                    </div>
                }
                {this.props.isCopyHome &&
                    <div style={{ display: 'inline-block', float: 'right' }}>
                        <button className="ogcButton btn-std-size" onClick={this.props.onClickSelectAll}>Select All</button>
                        <button className="ogcButton btn-std-size" onClick={this.props.onClickUnselectAll}>Unselect All</button>
                    </div>
                }
            </div>
        );
    }
}

class QuickLinks extends React.Component {
    displayName = QuickLinks.name;

    constructor(props) {
        super(props);

        this.responseStatus = 200;
        this.showEditControls = this.props.isAuthenticated && this.props.isEditHome &&
            (this.props.userRole === UserRoles.Administrator || this.props.userRole === UserRoles.SalesRep);

        this.state = {
            originalItems: [],
            items: [],
            load: false,
            editMode: EditState.List
        };
    }

    componentDidMount = async () => {
        const fetchConfig = {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        };

        this.setState({ load: true });
        const response = await fetch('api/home/quicklinks/', fetchConfig);
        if (response.ok) {
            let data = await response.json();

            var quickLink = data;

            quickLink.map((obj) => {
                obj.isChecked = false;
                return obj;
            });

            this.setState({ items: quickLink, load: false });
        }
        else if (response.status === 401) {
            this.props.signOut();
        }
        else {
            var err = await response.text();
            console.log(`Failed to load Quick Links: ${err}.`);
            toast.error("Failed to load Quick Links.");
        }
    };

    onChangeButtonText = (idx, e) => {
        let items = this.state.items;
        items[idx].buttonText = e.target.value;
        this.setState({ items: items });
        this.props.setDirty(true);
    }

    onChangeLink = (idx, e) => {
        let items = this.state.items;
        items[idx].link = e.target.value;
        this.setState({ items: items });
        this.props.setDirty(true);
    }

    onClickRemove = (idx, e) => {
        var items = this.state.items;
        items.splice(idx, 1);
        this.setState({ items: items });
        this.props.setDirty(true);
    }

    onClearItems = () => {
        this.setState({ items: [] });
        this.props.setDirty(true);
    }

    onClickEdit = (e) => {
        const deepCopy = this.state.items.map(a => Object.assign({}, a));
        this.setState({ editMode: EditState.Edit, originalItems: deepCopy });
    }

    onClickCancel = (e) => {
        this.setState({ editMode: EditState.List, items: this.state.originalItems });
        this.props.setDirty(false);
    }

    onClickAdd = (e) => {
        var items = this.state.items;
        items.push({
            index: this.state.items.length + 1,
            text: ''
        });
        this.setState({ editMode: EditState.Edit, items: items });
        this.props.setDirty(true);
    }

    onClickSubmit = async () => {
        const fetchConfig = {
            method: 'PUT',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`,
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify(this.state.items)
        };

        const response = await fetch('api/home/quicklinks/', fetchConfig);
        if (response.ok) {
            toast.success("Quick Links updated.");
            this.setState({ editMode: EditState.List });
            this.props.setDirty(false);
        }
        else if (response.status === 401) {
            toast.error("Unauthorized.");
            this.props.signOut();
        }
        else {
            toast.error(`Error saving Quick Links.`);
            console.log(`Error saving Quick Links: ${await response.text()}.`);
        }
    }

    setIsChecked = async (item) => {
        var quickLink = item;
        quickLink.isChecked = !quickLink.isChecked;

        await this.setState({ item });

        var items = this.state.items.filter(function (n) { return n.isChecked; });

        this.props.toggleAddToCopyHome('quickLinks', items);
    }

    onClickSelectAll = async () => {
        var items = this.state.items;

        items.map((obj) => {
            obj.isChecked = true;
            return obj;
        });

        await this.setState({ items });
        this.props.toggleAddToCopyHome('quickLinks', items);
    }

    onClickUnselectAll = async () => {
        var items = this.state.items;

        items.map((obj) => {
            obj.isChecked = false;
            return obj;
        });

        await this.setState({ items });
        this.props.toggleAddToCopyHome('quickLinks', []);
    }

    render() {
        return (
            <div>
                <ItemsHeader
                    editMode={this.state.editMode}
                    showEditControls={this.showEditControls}
                    onClickEdit={this.onClickEdit}
                    onClickCancel={this.onClickCancel}
                    onClickAdd={this.onClickAdd}
                    onClickSubmit={this.onClickSubmit}
                    isCopyHome={this.props.isCopyHome}
                    onClearItems={this.onClearItems}
                    onClickSelectAll={this.onClickSelectAll}
                    onClickUnselectAll={this.onClickUnselectAll}
                    isDirty={this.props.isDirty}
                />
                <ItemsList
                    items={this.state.items}
                    onClickRemove={this.onClickRemove}
                    editMode={this.props.isCopyHome === true ? EditState.List : this.state.editMode}
                    onChangeButtonText={this.onChangeButtonText}
                    onChangeLink={this.onChangeLink}
                    isCopyHome={this.props.isCopyHome}
                    setIsChecked={this.setIsChecked}
                />
            </div>
        );
    }
}

export default withRouter(connect(state => state.login,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(QuickLinks));


// WEBPACK FOOTER //
// ./src/components/Home/QuickLinks.js